import { AuthContext } from 'AuthContext'
import { EledoPageHeader } from 'components/library'
import React, { useContext, useEffect, useState } from 'react'
import classnames from "classnames";
import styles from 'components/library/EledoPageHeader.module.scss';
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useMutation } from '@apollo/client';
import { AuthenticateDataData, AuthenticateVars, GET_AUTHENTICATE } from 'graphql/AuthQueries';
import { setAllRequests } from '_reducers/puzzleRequests';
import { useAppDispatch } from '_store';
import { Tracker, TrackerUser } from 'Tracker';

type LocationState = {
  userId: string
  email: string
  provider: string
  from: {
    pathname: string
    search: string
  }
}

const EledoSsoRedirect = () => {
  const navigate = useNavigate()
  const auth = useContext(AuthContext);
  const state = useLocation().state as LocationState;
  const email = state?.email
  
  const query = new URLSearchParams(useLocation().search);
  const [result, setResult] = useState(query.get("result"))
  const token = query.get("token")
  const [error, setError] = useState(query.get("error"))
  const mergeUserId = query.get("mergeUserId")
  const provider = query.get("provider") || state?.provider || "google"

  const dispatch = useAppDispatch();
  const [doAuth, { loading, error: authError }] = useMutation<AuthenticateDataData, AuthenticateVars>(GET_AUTHENTICATE, {
      onCompleted(data, clientOptions) {
        if(data){
          
          if(data){
            if((data.authenticate.accounts?.length || 0) > 0){
              return navigate("/login/accountSelect", { state: { ...state, ...clientOptions?.variables, accounts: data.authenticate.accounts }})
            }

            if(data.authenticate.account == null){

              const trackerUser = {
                id: data.authenticate.user?.id || null,
                level: data.authenticate.level
              }
              
              Tracker.event("action.register.user", trackerUser, {
                register: {
                  type: "sso"
                }
              })
              
              return navigate("/login/createAccount", { state: { ...state, provider, ...clientOptions?.variables, accounts: data.authenticate.accounts }})
            }

            const authVars = clientOptions?.variables as AuthenticateVars
            
            auth.login(data.authenticate, authVars.type);
            
            if(data.authenticate.requests){
              dispatch(setAllRequests(data.authenticate.requests));
            }
  // console.log(state.from)
            if(data.authenticate.user != null){
              if(state?.from?.pathname){
                navigate(state.from.pathname + state.from.search);
              }else{
                navigate("/templates/mine");
              }
            }
          }
        }
      },
      onError(error){
        setResult("failure")
        setError(error.message)
      }
    });

  useEffect(() => {
    if(result == "failure"){
      return
    }
    
    if(result == "success" && token !== null){
      if(mergeUserId === null){
        const authenticate: AuthenticateVars = {
          type: "sso",
          payload: token
        }
        
        doAuth({ variables: authenticate });
      } else {
        navigate("/auth/linkAccount", { state: { token, userId: mergeUserId }})
      }
    } else if (email) {
      if(state?.from?.pathname){
        window.location.href = `${process.env.REACT_APP_ELEDO_BASE_URL}/openid/startsso?email=${encodeURIComponent(email)}&redirect=${encodeURIComponent(state.from.pathname + state.from.search)}`;
      }else{
        window.location.href = `${process.env.REACT_APP_ELEDO_BASE_URL}/openid/startsso?email=${encodeURIComponent(email)}&redirect=${encodeURIComponent(window.location.href)}`;
      }
    } else if(provider){
      if(state?.from?.pathname){
        window.location.href = `${process.env.REACT_APP_ELEDO_BASE_URL}/openid/startsso?provider=${encodeURIComponent(provider)}&redirect=${encodeURIComponent(state.from.pathname + state.from.search)}`;
      }else{
        window.location.href = `${process.env.REACT_APP_ELEDO_BASE_URL}/openid/startsso?provider=${encodeURIComponent(provider)}&redirect=${encodeURIComponent(window.location.href)}`;
      }
    }
  }, [result, token, email, provider]);

  if(!auth.canLetLogin){
    return (
      <Navigate to={{pathname: '/start'}}/>
    )
  }

  return (
    <div>
      <EledoPageHeader/>

      <div className={classnames(styles.EledoLogin, "container")} data-testid="EledoLogin">
        <div className="section section-small">
          <div className="hero-paragraph text-center">
            { email && provider &&
              <h2><b>Redirecting to identity provider...</b></h2>
            }
            { result === "success" &&
              <h2><b>Authenticating...</b></h2>
            }
            { result === "failure" &&
              <>
                <h2><b>Authentication Failed...</b></h2>
                <p>{error}</p>
                <button className={"button"} type="submit" onClick={() => navigate('/login/start')}>
                  Start Over
                </button>
              </>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default EledoSsoRedirect